import { render } from "./VerticalSkewBox.vue?vue&type=template&id=04da859c"
import script from "./VerticalSkewBox.vue?vue&type=script&lang=js"
export * from "./VerticalSkewBox.vue?vue&type=script&lang=js"

import "./VerticalSkewBox.vue?vue&type=style&index=0&id=04da859c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__